import { all, call, put, take, takeLatest } from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import saveReservationFormSettings from '../../models/User/saveReservationFormSettings'
import { UserAccountActions } from '../../reducers/userAccount/actionNames'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'

function* saveReservationFormSettingsInApi() {
  try {
    const allNames = fetchActionsName(ActionNames.SaveReservationFormSettingsInApi)
    const [allService] = yield all([
      take(allNames.output),
      put(
        callFetch(
          allNames.input,
          allNames.output,
          saveReservationFormSettings,
        ),
      ),
    ])

    yield call(allService.service)
  } catch (e) {
    console.error(e)
  }
}

export default function*() {
  yield takeLatest(
    UserAccountActions.SaveReservationFormSettings,
    saveReservationFormSettingsInApi,
  )
}
